import { render, staticRenderFns } from "./CancellationEndorsement.vue?vue&type=template&id=308623ee&scoped=true&"
import script from "./CancellationEndorsement.vue?vue&type=script&lang=js&"
export * from "./CancellationEndorsement.vue?vue&type=script&lang=js&"
import style0 from "./CancellationEndorsement.vue?vue&type=style&index=0&id=308623ee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308623ee",
  null
  
)

export default component.exports